import "./CoursePage.css"
import { FaArrowRight } from 'react-icons/fa';
import { useEffect } from "react";
import {Introduction} from "../ExportComponents"
import Cource from "./Cource";
import Union from "../../Photos/Photo/Union.png"

import { Helmet } from "react-helmet";


const CoursePage = ({CoursesDetails}) => {
    console.log(CoursesDetails)

    return (
        <>
            <div className="courseSection">
                <Introduction headline={"Learn With Us"} title={"Courses"} paragraph={"Discover industry-relevant courses designed to scale your skills and shape your future. Learn by doing, guided by experts."}/>

                <div className="coursesList">
                    <div className="row row1">
                        <Cource details={CoursesDetails[0]} />
                        <Cource  details={CoursesDetails[1]}/>
                    </div>
                    <div className="row row2">
                        <Cource details={CoursesDetails[2]} />
                        <Cource details={CoursesDetails[3]} />
                    </div>
                    <div className="lastRow">
                        <Cource details={CoursesDetails[4]} />
                    </div>
                    <img src={Union} alt="logo" className="backImageCourses"/>
                </div>
            </div>
        </>
    )
}
export default CoursePage;